import React from 'react';
import PropTypes from 'prop-types';
import InitWrapper from '../InitWrapper';
import { ChecklistIcon } from '../Svg/ChecklistIcon';
import { translate } from 'react-i18next';

import { EmptyState, TextButton, Heading } from 'wix-style-react';

function Welcome({ onTakePhoneOrderClick, t }) {
  return (
    <InitWrapper displayCta onTakePhoneOrderClick={onTakePhoneOrderClick}>
      <EmptyState
        image={<ChecklistIcon />}
        title={
          <Heading appearance="H3" data-hook="welcome-state-title">
            {t('phoneordering_emptystate_owner_newOrder_title')}
          </Heading>
        }
        subtitle={t('phoneordering_emptystate_owner_newOrder_subtitle')}
      >
        <TextButton dataHook="welcome-cta" onClick={() => onTakePhoneOrderClick()}>
          {t('phoneordering_emptystate_owner_newOrder_CTA')}
        </TextButton>
      </EmptyState>
    </InitWrapper>
  );
}

Welcome.displayName = 'Welcome';
Welcome.propTypes = {
  onTakePhoneOrderClick: PropTypes.func,
  t: PropTypes.func,
};

export default translate()(Welcome);